import { useEffect, useState } from "react"
import Typography from "@mui/material/Typography"
import "./interetsCvTwo.scss"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import CvSkillDto from "../../../../../api/models/cvskill"

interface InteretsCvTwoProps {
	theme?: ThemeCvDto | null
	cvSkill: CvSkillDto
}

function InteretsCvTwo({ theme, cvSkill }: InteretsCvTwoProps) {
	const [texts, setTexts] = useState<{ [key: string]: string }>({})

	useEffect(() => {
		if (cvSkill?.poleInterets) {
			const initialTexts = cvSkill.poleInterets.reduce(
				(acc, curr) => {
					acc[curr.interet] = ""
					return acc
				},
				{} as { [key: string]: string },
			)
			setTexts(initialTexts)
		}
	}, [cvSkill?.poleInterets])

	const handleTextChange = (
		e: React.ChangeEvent<HTMLInputElement>,
		key: string,
	) => {
		setTexts(prev => ({
			...prev,
			[key]: e.target.value,
		}))
	}

	return (
		<div className="interets-two">
			<div
				className="interets-two-bg"
				style={{
					backgroundImage: `url("${theme?.imagePrincipale}")`,
				}}
			/>

			<div className="interets-two-content">
				{cvSkill.poleInterets?.map(d => (
					<div key={d.interet}>
						<h1 className="interets-two-text">{d.interet}</h1>
						<Typography>
							<input
								id={d.interet}
								className={
									(texts[d.interet] || "").trim() === ""
										? "styleTextArea-2-two empty-for-print"
										: "styleTextArea-2-two filled-for-print"
								}
								value={texts[d.interet] || ""}
								onChange={e => handleTextChange(e, d.interet)}
								placeholder="Exprimez-vous...!"
							/>
						</Typography>
					</div>
				))}

				<h1 className="interets-two-loisirs-title">Loisirs :</h1>
				<Typography className="text-white">
					<h5 className="interets-two-loisirs-text">
						{cvSkill.poleLoisirInterets
							?.map(d => d.name)
							.filter(Boolean)
							.join(", ")}
					</h5>
				</Typography>
			</div>
		</div>
	)
}

export default InteretsCvTwo
